export function getfilterSetCanSeeCompletedActionType(feature) {
    return `filter-${feature}-can-see-completed-set`;
}

export function getfilterSetCanSeeHiddenActionType(feature) {
    return `filter-${feature}-can-see-hidden-set`;
}

export function getfilterSetCanSeeProjectActionType(feature) {
    return `filter-${feature}-can-see-project-set`;
}

export function getfilterSetCannotSeeProjectsActionType(feature) {
    return `filter-${feature}-cannot-see-projects-set`;
}

export function createFilterCanSeeAction(type, canSee) {
    return {
        type,
        canSee
    };
}

export function createFilterCanSeeProjectAction(type, id, canSee) {
    return {
        type,
        id,
        canSee
    };
}

export function createFilterCannotSeeProjectsAction(type, ids) {
    return {
        type,
        ids
    };
}
